import { useEffect, useState } from "react";

export function useSwUpdate() {
  const [updateReady, setUpdateReady] = useState(false);

  useEffect(() => {
    if (!("serviceWorker" in navigator)) return;

    // hadController: был ли уже активный SW до этой загрузки страницы.
    // Если нет — controllerchange это просто первая установка, не обновление.
    const hadController = Boolean(navigator.serviceWorker.controller);

    const onControllerChange = () => {
      if (hadController) setUpdateReady(true);
    };

    navigator.serviceWorker.addEventListener("controllerchange", onControllerChange);
    return () => navigator.serviceWorker.removeEventListener("controllerchange", onControllerChange);
  }, []);

  return { updateReady, reload: () => window.location.reload() };
}
